import * as React from "react";
const SvgScatterPlot = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 14,
  r: 3,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 6,
  r: 3,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16.6,
  cy: 17.6,
  r: 3,
  fill: "currentColor"
}));
export default SvgScatterPlot;